import { render, staticRenderFns } from "./CardMobile.vue?vue&type=template&id=67c4ae72&scoped=true&"
import script from "./CardMobile.vue?vue&type=script&lang=js&"
export * from "./CardMobile.vue?vue&type=script&lang=js&"
import style0 from "./CardMobile.vue?vue&type=style&index=0&id=67c4ae72&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c4ae72",
  null
  
)

component.options.__file = "CardMobile.vue"
export default component.exports